import { Navigate } from "react-router-dom";
import IndustryList from "../components/industryList";
import IndustryCreate from "../components/industryCreate";
import IndustryEditView from "../components/industryEditView";
import SvgIcons from "../../../../shared/components/svgIcons";
const industryRoute = {
  icon: SvgIcons.MasterDataIcon,
  name: "Master Data",
  link: "/master-datas",
  path: "/master-datas",
  element: "",
  index: 990,
  children: [
    {
      path: "industries",
      element: <IndustryList />,
      name: "Industries",
      permission: "Industry",
      index: 1,
      link: "master-datas/industries",
      icon: SvgIcons.IndustriesIcon,
    },
    {
      path: "industries/create",
      element: <IndustryCreate />,
    },
    {
      path: "industries/:id",
      element: <IndustryEditView />,
    },
    {
      path: "",
      element: <Navigate to="master-datas/industires" replace />,
    },
  ],
};
export default industryRoute;
